import { Box, Link } from "@chakra-ui/react";
import Marquee from "react-fast-marquee";
import { t, msg } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { useRouter } from 'next/router';

const showAnnouncement = true;
const Announcement = () => {
  if (!showAnnouncement) {
    return null;
  }
  const router = useRouter();
  const { pathname } = router;
  const { _, i18n } = useLingui();

  let link = "/overlays";
  let message = _(t`Sekarang Media share bisa menggunakan TikTok dan IG Reels! Silahkan Cek di pengaturan overlay.`);

  if (pathname.startsWith('/transactions/cashout') && ["id", "en"].includes(i18n.locale)) {
    link = "#";
    message = _(t`LinkAja lagi nggak bisa digunakan untuk cashout. Pilih e-wallet lain biar dana kamu tetap bisa ditarik, ya!`);
  }

  return (
    <Box w="100vw" bgColor="#faae2b">
      <Link href={link} >
        <Marquee gradient={false} speed={100}>
          <Box w="max-content" ml={5}>
            {message}
          </Box>
        </Marquee>
      </Link>
    </Box>
  );
};

export { Announcement };
